// extracted by mini-css-extract-plugin
export default {"downloadGroupButton":"BymaDownloadButton_downloadGroupButton__ZxDgX"};